import { RootState } from '../../../root-saga/root-state';
import { DashboardKey } from './types';

export const selectAdminDashboardState = (state: RootState) => state.adminDashboard;

export function makeDashboardKey(productId: string): DashboardKey {
  return `${productId}`;
}

export function selectChatSessions(state: RootState) {
  return selectAdminDashboardState(state).chatSessions;
}

export function selectCallSessions(state: RootState) {
  return selectAdminDashboardState(state).callSessions;
}

export function selectIsLoading(state: RootState) {
  return selectAdminDashboardState(state).isLoading;
}

export function selectError(state: RootState) {
  return selectAdminDashboardState(state).error;
}

export function selectLatestTimeLineItems(state: RootState) {
  return selectAdminDashboardState(state).latestTimeLineItems;
}